import Swiper from "swiper";
import { Navigation, Thumbs } from "swiper/modules";

class ColorPickerModal {
  constructor() {
    this.modalInit();
    this.sliderInit();
    this.changeSelected();
  }

  modalInit = () => {
    const btns = document.querySelectorAll(".js-picker-modal-btn");
    const modal = document.querySelectorAll(".js-picker-modal");
    const exits = document.querySelectorAll(".js-picker-modal-exit");
    modal.forEach((m) => {
      m.addEventListener("click", (e) => {
        if (e.target.classList.contains("js-picker-modal")) {
          m.classList.remove("active");
        }
      });
    });

    btns.forEach((btn, index) => {
      btn?.addEventListener("click", () => {
        modal[index].classList.add("active");
      });
    });
    exits.forEach((exit, index) => {
      exit?.addEventListener("click", () => {
        this.modalsClose();
      });
    });
  };

  modalsClose = () => {
    const modals = document.querySelectorAll(".js-picker-modal");
    modals.forEach((modal) => {
      modal.classList.remove("active");
    });
  };

  sliderInit = () => {
    const modals = document.querySelectorAll(".js-picker-modal");
    modals.forEach((modal) => {
      let tabs = modal?.querySelector(".js-picker-tabs");
      let tabsSlider = new Swiper(tabs, {
        slidesPerView: "auto",
        spaceBetween: 20,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          1280: {
            spaceBetween: 0,
          },
        },
      });
      let picker = modal?.querySelector(".js-picker-slider");
      let pickerSlider = new Swiper(picker, {
        slidesPerView: 1,
        modules: [Thumbs, Navigation],
        navigation: {
          prevEl: ".picker-button-prev",
          nextEl: ".picker-button-next",
        },
        thumbs: {
          swiper: tabsSlider,
          autoScrollOffset: 1,
        },
      });
    });
  };

  changeSelected = () => {
    const btns = document.querySelectorAll(".js-picker-select");
    const containers = document.querySelectorAll(".js-picker-select-container");

    if (btns.length == 0 || containers.length == 0) {
      return;
    }
    btns.forEach((btn, index) => {
      btn?.addEventListener("click", () => {
        let slide = btn.parentNode.querySelector(".swiper-slide-active");
        let image = slide.querySelector("img");
        if (containers[index].classList.contains("duplicate-picker-btn")) {
          let duplicateContainers = document.querySelectorAll(
            ".duplicate-picker-btn"
          );
          duplicateContainers.forEach((c) => {
            c.innerHTML = "";
            c.appendChild(image.cloneNode(true));
            c.setAttribute("data-title", btn.getAttribute("data-title"));
          });
        } else {
          containers[index].innerHTML = "";
          containers[index].appendChild(image.cloneNode(true));
          containers[index].setAttribute(
            "data-title",
            btn.getAttribute("data-title")
          );
        }
        this.modalsClose();
      });
    });
  };
}

export default ColorPickerModal;
